import { render, staticRenderFns } from "./UnsentCurriculumsQuery.vue?vue&type=template&id=996c7f50&lang=pug"
import script from "./UnsentCurriculumsQuery.vue?vue&type=script&lang=js"
export * from "./UnsentCurriculumsQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports